/* eslint no-alert: 0 */

import * as Turbo from "@hotwired/turbo";
import Components from "../javascripts/components";
import ErrorHelpers from "../javascripts/error_helpers";
import Rails from "@rails/ujs";
import "./turbo_stream_actions/dispatch_event";

Rails.start();

$(document).on("ajax:before", "[data-remote]", () => {
  Turbo.cache.clear();
});

$(document).on("ajax:before", "[data-remote][data-container]", (event) => {
  $(event.target).data("type", "html");
});

$(document).on("ajax:complete", "[data-remote][data-container]", (event) => {
  const response = event.originalEvent.detail[0];
  const contentType = response.getResponseHeader("Content-Type");
  // If we receive a 205 response, we follow the spec and refresh the page
  if (response.status === 205) {
    window.location.reload();
    return;
  }

  if (contentType && contentType.match(/^text\/(html|plain)/)) {
    if (response.status >= 200 && response.status <= 299) {
      const $form = $(event.target);
      const selector = $form.data("container");
      let $container = $form.closest(selector);
      if ($container.length === 0) {
        $container = $(selector);
      }

      const $dataEl = $(response.responseText);
      const operation = String($form.data("operation")).toLowerCase();

      switch (operation) {
        case "append":
          $container.append($dataEl);
          break;
        case "replace":
          $container.replaceWith($dataEl);
          break;
        case "prepend":
          $container.prepend($dataEl);
          break;
        case "remove":
          $container.remove();
          break;
        default:
          $container.html($dataEl);
      }

      if ($form.data("reset")) {
        $form[0].reset();
      }

      if ($form.data("reload-fragment") && operation !== "remove") {
        Components.collection.loadFragment($dataEl);
      }

      $container.trigger("ajax:rendered");
    }
  }
});

$(document).on("ajax:error", "[data-remote][data-show-errors]", (event) => {
  const xhr = event.originalEvent.detail[2];
  const errorJson =
    xhr.getResponseHeader("X-Xhr-Form-Errors") || xhr.responseText;
  if (xhr.status === 422 && errorJson) {
    try {
      ErrorHelpers.showErrors(
        event.target,
        $.parseJSON(errorJson),
        $(event.target).data("show-errors"),
      );
    } catch {
      alert("An error was encountered");
    }
  }
});

$(document).on(
  "change",
  "[data-remote][data-update-on-change] input[type=checkbox]",
  (event) => {
    Rails.fire($(event.target).parents("form")[0], "submit");
  },
);
